import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiValidation} from '../../model/api/api-validation';
import {ParentAPIService} from "../parent.api.service";
import {CrystalclearSupportBackUrl} from "../config/crystalclear-support-back-url";
import {FieldResult} from "../../model/api/field-result";
import {GatewayConnection} from "../../model/hub/gateway-connection";

@Injectable({
  providedIn: 'root'
})
export class SyncService extends ParentAPIService {

  constructor(http: HttpClient) {
    super(http);
  }

  public doSync(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SYNC_SUPPORT_SYNC_ALL);
  }

  public doSyncStatics(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SYNC_SUPPORT_SYNC_STATICS);
  }

  public doSyncPublisher(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SYNC_SUPPORT_SYNC_PUBLISHER);
  }

  public doSyncAllGw(): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SYNC_SUPPORT_SYNC_ALL_GW);
  }

  public doSyncSingleGw(gwId: string): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SYNC_SUPPORT_SYNC_SINGLE_GW, undefined, {gatewayName: gwId});
  }

  public getConnectedGws(): Observable<FieldResult<GatewayConnection>> {
    return this.post(CrystalclearSupportBackUrl.SYNC_SUPPORT_CONNECTED_GWS);
  }

}
